/* A decorative lunar cabinet; never delays date content or changes astronomy. */
(function () {
  'use strict';
  const root = document.querySelector('[data-whispers-calendar]');
  const opening = root?.querySelector('[data-calendar-opening]');
  if (!opening) return;
  const stage = opening.querySelector('.grc__theatre-stage');
  const left = opening.querySelector('[data-lunar-left]');
  const right = opening.querySelector('[data-lunar-right]');
  const ring = opening.querySelector('[data-lunar-ring]');
  const orb = opening.querySelector('[data-lunar-orb]');
  const symbol = opening.querySelector('[data-lunar-symbol]');
  const plaque = opening.querySelector('[data-lunar-plaque]');
  const art = opening.querySelector('[data-lunar-art]');
  const replay = opening.querySelector('[data-lunar-replay]');
  const skip = opening.querySelector('[data-lunar-skip]');
  const dateTitle = root.querySelector('[data-calendar-details-title]');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let animations = [];
  let revision = 0;
  let waiting = null;
  const supported = typeof left.animate === 'function';

  function settle(restoreFocus = false) {
    revision += 1;
    waiting?.disconnect(); waiting = null;
    animations.forEach(animation => animation.cancel()); animations = [];
    opening.classList.remove('is-opening');
    const controlsHidden = reduced.matches || !supported;
    if (restoreFocus && (document.activeElement === skip || (controlsHidden && document.activeElement === replay))) {
      (controlsHidden ? dateTitle : replay)?.focus({ preventScroll: true });
    }
    skip.hidden = true;
    replay.hidden = controlsHidden;
  }
  function play() {
    settle();
    if (reduced.matches || !supported || document.hidden) return;
    const current = revision;
    opening.classList.add('is-opening'); skip.hidden = false;
    const ease = 'cubic-bezier(.22,.61,.36,1)';
    animations = [
      left.animate([{ transform: 'rotateY(0deg)' }, { transform: 'rotateY(-108deg)' }], { duration: 1050, easing: ease }),
      right.animate([{ transform: 'rotateY(0deg)' }, { transform: 'rotateY(108deg)' }], { duration: 1150, easing: ease }),
      ring.animate([{ transform: 'rotate(-48deg)' }, { transform: 'rotate(0deg)' }], { duration: 1250, easing: ease }),
      orb.animate([{ transform: 'translateY(16px) scale(.78)', opacity: .5 }, { transform: 'translateY(0) scale(1)', opacity: 1 }], { duration: 1050, easing: ease })
    ];
    Promise.all(animations.map(animation => animation.finished)).then(() => {
      if (revision === current) settle(true);
    }).catch(() => { /* Cancelled by a newer date, skip, or motion preference. */ });
  }
  function whenVisible() {
    settle();
    if (reduced.matches || !supported) return;
    const rect = stage.getBoundingClientRect();
    if (rect.top >= 0 && rect.bottom <= window.innerHeight) { play(); return; }
    if (!('IntersectionObserver' in window)) return; // Static rather than animate off-screen.
    const current = revision;
    const observer = new IntersectionObserver(entries => {
      // Disconnect cannot retract an already queued callback for a previous date.
      if (revision !== current || waiting !== observer) return;
      if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); waiting = null; play(); }
    }, { threshold: .65 });
    waiting = observer;
    observer.observe(stage);
  }
  root.addEventListener('wote:calendar-date', event => {
    settle();
    const detail = event.detail || {};
    opening.hidden = Boolean(detail.empty);
    if (detail.empty) return;
    orb.dataset.phase = ['new', 'first', 'full', 'last'].includes(detail.phase) ? detail.phase : 'symbol';
    symbol.textContent = detail.glyph || '✦';
    plaque.textContent = detail.label || 'The lunar cabinet';
    // Image URLs come from the existing Shopify file map, never from user input.
    if (detail.image) art.style.setProperty('--lunar-event-art', `url(${JSON.stringify(detail.image)})`);
    else art.style.removeProperty('--lunar-event-art');
    if (detail.animate) whenVisible();
  });
  replay.addEventListener('click', play);
  skip.addEventListener('click', () => settle(true));
  reduced.addEventListener('change', () => settle(true));
  document.addEventListener('visibilitychange', () => { if (document.hidden) settle(true); });
  window.addEventListener('pagehide', () => settle());
  settle();
})();
